import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { BaseComponent, IBaseComponentProps } from "../../Common/BaseComponent/BaseComponent";
import { DataLabel } from "../../Common/DataLabel/DataLabel";
import { DataType } from "../../Common/SharedEnums/SharedEnums";
import { VideoPlayPanel } from "../../Common/VideoPlayPanel/VideoPlayPanel";

import Link = EventLibrary.Model.Link;
import { $$requestManager } from "../../Core/RequestManager";

export interface IEventViewerProps extends IBaseComponentProps
{
    onLoad?: Function;
}

interface IState
{
    data: EventLibrary.Model.EventInstance;
}

declare var Viewer;

export class EventViewer extends BaseComponent<IEventViewerProps, IState>
{
    private _pnlContent: HTMLElement;
    private _pnlImages: HTMLElement;
    private _imgViewer;

    constructor(props: IEventViewerProps)
    {
        super(props);
    }

    public setData(data)
    {
        this.setState({ data: data });
    }

    private _renderImages(images: any[])
    {
        if (images?.length > 0)
        {
            return (
                <preact.Fragment>
                    {
                        images.map((image) =>
                        {
                            return (<img src={"api/image/GetImage?id=" + image.Id} style="max-Height: 200px; border-radius: 2px; padding: 10px 4px; cursor: pointer;" />)
                        })
                    }
                </preact.Fragment>
            );
        }
        else
        {
            return null;
        }
    }

    private _renderLinks(links: Link[])
    {
        if (links?.length > 0)
        {
            return (
                <div style={{ marginTop: "10px" }}>
                    {
                        links.map((link: Link) =>
                        {
                            return (<div style="font-size: 13px;">{link.Description}: <a href={link.Url} target="_blank" rel="noreferrer noopener">{link.Url}</a></div>);
                        })
                    }
                </div>
            );
        }
        else
        {
            return null;
        }
    }

    private _renderTopics(topics: KeyValue[])
    {
        if (topics?.length > 0)
        {
            return (
                <div className="topics">
                    {
                        topics.map((topic: KeyValue, index: number) =>
                        {
                            return (<span className="topic" title={topic.Context || ""}>{topic.Value}</span>)
                        })
                    }
                </div>
            );
        }
        else
        {
            return null;
        }
    }

    private _renderPeople(people: KeyValue[])
    {
        if (people?.length > 0)
        {
            return (
                <preact.Fragment>
                    <div class="headerLine"><label class="viewerHeader">People</label></div>
                    {
                        people.map((person: KeyValue, index: number) =>
                        {
                            return (
                                <a href={person.Url} target="_blank" className="person" title={person.Value || ""}>
                                    <img src={`api/image/GetImage?personid=${person.Key}`} /><br />{person.Value}
                                </a>
                            );
                        })
                    }
                </preact.Fragment>
            );
        }
        else
        {
            return null;
        }
    }


    private _renderOrganizations(orgs: KeyValue[])
    {
        if (orgs?.length > 0)
        {
            return (
                <div className="related" style="font-size: 14px">
                    <div class="headerLine"><label class="viewerHeader">Organizations</label></div>
                    {
                        orgs.map((org: KeyValue, index: number) =>
                        {
                            return (<div>{org.Value + " " + (org.Context || "")}</div>);
                        })
                    }
                </div>
            );
        }
        else
        {
            return null;
        }
    }

    public load(eventId)
    {
        $$requestManager.execute("api/event/load", eventId, this._onLoadSuccess.bind(this));
    }

    private _onLoadSuccess(data: EventLibrary.Model.EventInstance)
    {
        this.setData(data);
        if (this.props.onLoad)
        {
            this.props.onLoad();
        }
        this._pnlContent.scrollTop = 0;
    }

    public getTitle()
    {
        return this.state.data.Name;
    }

    public override componentDidMount()
    {
        super.componentDidMount();
        if (!this._imgViewer)
        {
            setTimeout(() =>
            {
                this._imgViewer = new Viewer(this._pnlImages, {
                    toolbar:
                    {
                        prev: { show: 2, size: 'large' },
                        next: { show: 2, size: 'large' }
                    },
                });
            }, 0);
        }
    }

    public render(props, state: IState)
    {
        let data = state.data || {} as EventLibrary.Model.EventInstance;
;
        return (
            <div ref={(ref) => this._registerContainer(ref)} className="eventViewer" style={{ display: "flex", flexFlow: "column", height: "100vh" }} >
                <div style="flex:0 0 auto; padding: 20px 16px 10px; min-height: 70px; border-bottom: 6px solid rgb(131 154 183); background-color: #333; position: relative">
                    <div style={{ color: "#fefefe", fontSize: "18px", fontWeight: "bold" }}>
                        { data.Name }
                    </div>
                    <div style={{ color: "#ccc", fontStyle: "italic" }}>
                        {$$.formatFlexDate(data.Start)}
                        {data.End ? " - " + $$.formatFlexDate(data.End) : null}

                    </div>
                    <div style={{ color: "#ccc" }}>
                        { data.Location?.Name || null }
                    </div>
                    { this._renderTopics(data.Topics) }
                </div>

                <div ref={(ref) => this._pnlContent = ref} style={{ flex: "1 1 auto", marginTop: "8px", overflow: "auto", padding: "5px 15px 20px 20px" }}>
                    <div style={{ whiteSpace: "pre-wrap", paddingTop: "10px", paddingBottom: "15px", color: "#333", fontSize: "15px" }}>
                        <DataLabel Type={DataType.Html} Content={ data.Details } ShowMoreHeight={250} />
                    </div>

                    <div ref={(ref) => this._pnlImages = ref} style={{ marginTop: "10px" }} >
                        {this._renderImages(data.Images)}
                    </div>

                    <VideoPlayPanel Videos={data.Videos} style={{ marginBottom: "10px" }} />

                    { this._renderPeople(data.Actors) }
                    { this._renderOrganizations(data.Organizations) }               
                    { this._renderLinks(data.Links) }
                </div>
            </div>
        );
    }
}